//  Copyright (c) 2014 Readium Foundation and/or its licensees. All rights reserved.
//
//  Redistribution and use in source and binary forms, with or without modification,
//  are permitted provided that the following conditions are met:
//  1. Redistributions of source code must retain the above copyright notice, this
//  list of conditions and the following disclaimer.
//  2. Redistributions in binary form must reproduce the above copyright notice,
//  this list of conditions and the following disclaimer in the documentation and/or
//  other materials provided with the distribution.
//  3. Neither the name of the organization nor the names of its contributors may be
//  used to endorse or promote products derived from this software without specific
//  prior written permission.

import URI from 'urijs';
import _ from 'underscore';
import Signature from '@axisnow/crypto/signature';
import Encryption from '@axisnow/crypto/encryption';
import Errors from '@axisnow/util/Errors';

//var _data;
var signature = new Signature();
var encryption = new Encryption();
//var _contentKey;

var License = function(data, key) {
  Object.defineProperty(this, '_key', {
    value: key,
    writable: false,
    enumerable: false,
  });

  Object.defineProperty(this, '_data', {
    value: data,
    writable: true,
    enumerable: false,
  });

  var self = this;

  console.log('License Data (' + data.id + ')');
  //console.log(JSON.stringify(data));
  _.extend(self, data);

  if (self.issued) {
    self.issued = new Date(self.issued);
  }
  if (self.rights.start) {
    self.rights.start = new Date(self.rights.start);
  }
  if (self.rights.end) {
    self.rights.end = new Date(self.rights.end);
  }

  /*for (var i in self) {
				if (!self.hasOwnProperty(i)) {
				  Object.defineProperty(self, i, { writable: false });
				}

            }*/

  //TODO Disabled to allow it to work for safari.  Ideally we should find a way to prevent modification to the license file that works in safari
  //deepFreeze(self);
};

//Internal Functions
var isObject = function(a) {
  return Object.prototype.toString.call(a) === '[object Object]';
};

var copyObjectWithSortedKeys = function(object) {
  if (isObject(object)) {
    var newObj = {};
    var keysSorted = Object.keys(object).sort();
    var key;
    for (var i = 0, len = keysSorted.length; i < len; i++) {
      key = keysSorted[i];
      newObj[key] = copyObjectWithSortedKeys(object[key]);
    }
    return newObj;
  } else if (Array.isArray(object)) {
    return object.map(copyObjectWithSortedKeys);
  } else {
    return object;
  }
};

function deepFreeze(obj) {
  // Retrieve the property names defined on obj
  var propNames = Object.getOwnPropertyNames(obj);

  // Freeze properties before freezing self
  propNames.forEach(function(name) {
    var prop = obj[name];

    // Freeze prop if it is an object
    if (typeof prop == 'object' && prop !== null) deepFreeze(prop);
  });

  // Freeze self (no-op if already frozen)
  return Object.freeze(obj);
}

//Public API
License.prototype.isValidAndNotExpired = function() {
  //var self = this;
  return this.isValid()
    .bind(this)
    .then(function() {
      var isExpired = this.isExpired();
      if (isExpired) {
        var title = 'Checkout has expired';
        var message = [
          'Your checkout expired on ' + this.rights.end.toLocaleDateString(),
          'To access this book please check it out again on your library’s e-collection',
        ];
        var type = 'Warning';

        throw new Errors.LicenseExpired(title, message, type); //Error("License is expired or invalid");
      }
      return this;
    });
};

License.prototype.isExpired = function() {
  var currentDate = new Date();
  return this.rights.end < currentDate.getTime();
};

License.prototype.isValid = function() {
  var signatureObj = this.signature;
  var canonicalStr = this.canonicalString();
  console.log(canonicalStr);
  return signature.verify(
    signature.getAlgorithm(signatureObj.algorithm),
    this._key.privateKey,
    signatureObj.value,
    canonicalStr,
  );
};

License.prototype.canonicalString = function() {
  //'{"drmrights":{"Copy":{"Permission":"'+this.drmrights.Copy.Permission+'","Days":"'+this.drmrights.Copy.Days+'","Percentage":"'+this.drmrights.Copy.Percentage+'","Watermark":"'+this.drmrights.Copy.Watermark+'","Copyright":"'+this.drmrights.Copy.Copyright+'","Notice":'+this.drmrights.Copy.Notice+'},"Devices":"'+this.drmrights.Devices+'","Preview":{"Measurement":'+this.drmrights.Preview.Measurement+',"Quantity":"'+this.drmrights.Preview.Quantity+'"},"Print":{"Permission":"'+this.drmrights.Print.Permission+'","Days":"'+this.drmrights.Print.Days+'","Percentage":"'+this.drmrights.Print.Percentage+'","Watermark":"'+this.drmrights.Print.Watermark+'","Copyright":"'+this.drmrights.Print.Copyright+'","Notice":'+this.drmrights.Print.Notice+'},"Reflow":"'+this.drmrights.Reflow+'","ttsread":"'+this.drmrights.ttsread+'"},"encryption":{"Profile":null,"ContentKey":{"Algorithm":null,"Encrypted_Value":"358f974b-a9cb-4db5-b8f2-95ce93b6c7cd"},"UserKey":{"Text_Hint":null,"Algorithm":null,"Key_Check":null}},"IssuedDate":"2016-02-09T17:42:49.233Z","LicenseID":"ab9b986c-6ef1-47bd-a67b-380652845c2f","Links":{"Link":null},"Provider":"Baker And taylor","rights":{"Print":"0","Copy":"0","tts":"false","start":"2016-02-09T17:42:49.233Z","end":"2016-02-10T17:42:49.173Z"},"version":"1"}'
  var data = _.omit(this._data, 'signature');
  return JSON.stringify(copyObjectWithSortedKeys(data));
};

License.prototype.getContentKey = function(uri, algo) {
  uri = URI.parse(uri).fragment.split('/');
  if (typeof algo == 'string') {
    algo = encryption.getAlgorithm(algo);
  }

  var contentKeyObj = this;
  uri.forEach(function(element, index, array) {
    if (element != '') contentKeyObj = contentKeyObj[element];
  });

  //Currently using license document version 1, so the algorithm is not accurate.
  var wrapperKeyAlgo = encryption.getRSAOAEP('SHA-1');

  var wrappedKey = encryption.utils.base64ToArr(contentKeyObj.encrypted_value);

  return encryption.unwrapKey(algo, wrappedKey, wrapperKeyAlgo, this._key.privateKey);
};

export default License;
